import { useRef, useState } from 'react';
import { MyConnectionPanel } from './MyConnectionPanel';
import { PasswordField } from './PasswordField';
import { RecentCodeField } from './RecentCodeField';

/** 파트너 코드/agentId + (선택) 세션·무인 비밀번호로 접속 요청. */
export function ConnectView({
  onConnect,
  busy,
}: {
  onConnect: (target: string, password?: string) => void;
  busy: boolean;
}) {
  const [code, setCode] = useState('');
  const [pw, setPw] = useState('');
  const pwRef = useRef<HTMLInputElement>(null);
  const connect = () => code.trim() && onConnect(code, pw || undefined);

  return (
    <div className="view">
      {/* 내 연결(피제어) — 로그인 전 화면과 **같은 컴포넌트**를 쓴다(MyConnectionPanel 주석 참조). */}
      <MyConnectionPanel />

      <h2>원격 접속</h2>
      <div className="field">
        <label>파트너 코드 (또는 agentId)</label>
        {/* 최근 접속한 코드(2026-10-23 사용자 요청 — 첫 화면과 같은 목록·같은 칸). 성공한 코드만 · 비밀번호는 저장하지 않는다. */}
        <RecentCodeField
          value={code}
          onChange={setCode}
          onPicked={() => pwRef.current?.focus()}
          onEnter={connect}
          placeholder="예: 617-088-148"
        />
      </div>
      <div className="field">
        <label>비밀번호 (세션/무인, 선택)</label>
        <PasswordField
          inputRef={pwRef}
          value={pw}
          onChange={setPw}
          aria-label="접속 비밀번호"
          style={{ width: '100%' }}
          onKeyDown={(e) => e.key === 'Enter' && connect()}
        />
      </div>
      <button onClick={connect} disabled={busy || !code.trim()}>
        {busy ? '연결 중…' : '연결'}
      </button>
      <p className="hint" style={{ marginTop: 16 }}>
        상대 기기의 파트너 코드를 입력하고 연결하세요. 승인(또는 무인 비밀번호 일치) 후 화면이 표시됩니다.
      </p>
    </div>
  );
}
